import { useSearchParams } from 'react-router-dom';

import { useValidRoutePaths } from '../context/ValidRoutePathsContext';
import { getSafeRedirectPath } from '../utils';

export const useSafeRedirectPath = () => {
  const [searchParams] = useSearchParams();
  const validRoutePaths = useValidRoutePaths();
  return getSafeRedirectPath(searchParams.get('redirect'), validRoutePaths);
};
